<script>
import AjaxLoad from "@/components/commonComponents/AjaxLoad.vue";
import CommonRules from "@/mixins/CommonRules";
import _ from "lodash";
import SessionSummary from "@/components/Session/SessionSummary.vue";
import SessionTranscription from "@/components/Session/SessionTranscription.vue";
import Comments from "@/components/commonComponents/Comments.vue";
import DownloadFile from "@/mixins/DownloadFile";
import VIconTooltip from "@/components/commonComponents/VIconTooltip.vue";
import roscongressUrl from "@/utils/roscongressUrl";

export default {
    name: "ForumEventSession",
    components: {
        VIconTooltip,
        Comments,
        SessionTranscription,
        SessionSummary,
        AjaxLoad,
    },
    mixins: [
        CommonRules,
        DownloadFile,
    ],
    data() {
        return {
            sessionRc: {},
            session: {},
            tab: null,
            dictionaries: {
                session2id: [],
            },
            resolved: {
                sessionRc: false,
                session2id: false,
                session: false,
            },
        };
    },
    computed: {
        idProject() {
            return this.$store.getters.breadCrumbs.event?.EPS_PROJECT_ID?.VALUE || null;
        },
        idSessionEps() {
            return parseInt(this.sessionRc?.ID_PD?.VALUE || 0);
        },
        idSession() {
            return _.find(this.dictionaries.session2id, {id_session_eps: this.idSessionEps})?.id || 0;
        },
        loading() {
            const resolved = this.resolved;
            return !resolved.sessionRc || (!!this.idProject && !resolved.session2id) || (!!this.idSession && !resolved.session);
        },
        sessionRoscongressUrl() {
            const code = this.sessionRc?.CODE;
            return code && roscongressUrl.getSessionUrl({code});
        },
        sessionRoscongressBitrixUrl() {
            const id_session_bitrix = this.sessionRc?.ID;
            return id_session_bitrix && roscongressUrl.getSessionBitrixUrl({id_session_bitrix});
        },
    },
    methods: {
        downloadSummary() {
            return this.getFile(this.$apiUrl.getSessionDownloadSummaryFullUrl({
                id: this.session.id,
                id_project: this.idProject
            }));
        },
        downloadTranscription() {
            return this.getFile(this.$apiUrl.getSessionDownloadTranscriptionFullUrl({
                id: this.session.id,
                id_project: this.idProject
            }));
        },
    },
}
</script>

<template>
    <v-container fluid class="down-top-padding">
        <v-row>
            <v-col>
                <ajax-load
                    v-model="sessionRc"
                    :active="!!$route.params.ID_SESSION"
                    :url="$apiUrl.getForumEventSessionUrl($route.params)"
                    :transform="response => response.data.data.items[0]"
                    :resolved.sync="resolved.sessionRc"
                ></ajax-load>
                <ajax-load
                    v-model="dictionaries.session2id"
                    :active="idProject"
                    :url="$apiUrl.getSessionsUrl({id_project: idProject})"
                    :transform="response => response.data.data"
                    :resolved.sync="resolved.session2id"
                ></ajax-load>
                <ajax-load
                    v-model="session"
                    :active="idSession"
                    :url="$apiUrl.getSessionUrl({id: idSession, id_project: idProject})"
                    :transform="response => response.data.data"
                    :resolved.sync="resolved.session"
                ></ajax-load>

                <v-card :loading="loading">
                    <v-card-title>
                        {{ sessionRc.NAME }}
                        <!--
                        @TODO С длинными названиями кнопки будут "съезжать" вниз...
                        -->
                        <v-spacer></v-spacer>

                        <v-icon-tooltip
                            v-if="sessionRoscongressUrl"
                            :href="sessionRoscongressUrl"
                            icon="mdi-web-check"
                            target="_blank"
                        >
                            Открыть сессию на Портале
                        </v-icon-tooltip>

                        <v-icon-tooltip
                            v-if="sessionRoscongressBitrixUrl"
                            :href="sessionRoscongressBitrixUrl"
                            icon="$ls-web-cog"
                            target="_blank"
                        >
                            Открыть сессию в Битрикс
                        </v-icon-tooltip>

                        <!-- @TODO: кнопки заменить на иконки? или отступ между кнопками и иконками? -->

                        <v-tooltip
                            bottom
                        >
                            <template v-slot:activator="{on}">
                                <div v-on="on">
                                    <v-btn
                                        v-if="session?.summary?.key_summary"
                                        @click.prevent="downloadSummary"
                                        class="mr-4"
                                        ripple
                                    >
                                        <v-icon left>
                                            mdi-download
                                        </v-icon>
                                        Саммари
                                    </v-btn>
                                    <v-btn
                                        v-if="session?.transcription?.key_transcription"
                                        @click.prevent="downloadTranscription"
                                        ripple
                                    >
                                        <v-icon left>
                                            mdi-download
                                        </v-icon>
                                        Транскрибация
                                    </v-btn>
                                </div>
                            </template>
                            Документы, предоставленные <br/>генеративной системой
                        </v-tooltip>
                    </v-card-title>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card>
                    <v-tabs v-model="tab">
                        <v-tab tab-value="summary">Саммари</v-tab>
                        <v-tab tab-value="transcription">Транскрибация</v-tab>
                    </v-tabs>
                    <v-tabs-items v-model="tab">
                        <v-tab-item value="summary">
                            <session-summary
                                :session="session"
                                :id-project="idProject"
                                :id-session-eps="idSessionEps"
                            ></session-summary>
                        </v-tab-item>
                        <v-tab-item value="transcription">
                            <session-transcription
                                :session="session"
                                :id-project="idProject"
                            ></session-transcription>
                        </v-tab-item>
                    </v-tabs-items>
                </v-card>
            </v-col>
            <v-col cols="3" v-if="idProject && idSession">
                <v-card height="100%">
                    <v-toolbar flat>
                        <v-toolbar-title>Комментарии</v-toolbar-title>
                    </v-toolbar>
                    <comments
                        :url="$apiUrl.getSessionCommentsUrl({id_project: idProject, id: idSession})"
                    ></comments>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<style scoped lang="scss">
.v-tabs {
    border-bottom: 1px solid #c0c0c044;
}
</style>
